module.exports = __webpack_public_path__ + "img/Hero-mobile@2x.3fbf7b53.png";